// extracted by mini-css-extract-plugin
module.exports = {"blogItem":"styles_blogItem__40CjG","blogItemTitle":"styles_blogItemTitle__t63HJ","blogItemImage":"styles_blogItemImage__e2AUy","blogItemDate":"styles_blogItemDate__L8gcn"};